import { dispatch, getState } from '../../..';
import PumpingStationFilterTypeHelper, { IPumpingStationFilterType } from '../../../../@types/model/masterData/pumpingStation/filterType';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationFilterTypeActions from './actions';

export default class MasterDataPumpingStationFilterTypeFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationFilterTypeFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationFilterTypeActions.setLoading(true));
        dispatch(MasterDataPumpingStationFilterTypeActions.set([]));

        try {
            MasterDataPumpingStationFilterTypeFunctions.listener = PumpingStationFilterTypeHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationFilterType>) => {
                    const state = getState().masterData.pumpingStation.filterType;

                    const list = state.filterTypes.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationFilterTypeActions.set(list));
                    dispatch(MasterDataPumpingStationFilterTypeActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationFilterTypeActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationFilterTypeActions.setLoading(false));
                    MasterDataPumpingStationFilterTypeFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationFilterTypeActions.setLoading(false));
        }
    };
}